export default __webpack_public_path__ + "static/media/2-1.89153d6e.mp3";